import { useModalStore } from "@/store/modal";

export default {
  install(app) {
    app.config.globalProperties.$modal = {
      open({ component = null, props = {} }) {
        const store = useModalStore();
        store.open({ component, props });
      },
      close() {
        const store = useModalStore();
        store.close();
      },
    };
  },
};
